<ng-container>
  <div class="logout-carlisle">
    <div class="justify-content-center" class="carlisle-logo-container">
         <img src="images/Henry-login_logo.webp"/>
    </div>

    <div class="logout-description">
      Thank you for visiting.

      <p>For security reasons, we recommend you close this current tab or login.</p>
    </div>


    <button type="button" class="w-25 btn btn-primary" (click)="routeToLogin()">Login</button>
  </div>
</ng-container>